<div [formGroup]="materialConsumptionRowForm" class="material-row pt-3">
    <fieldset [ngClass]="{ 'ng-invalid': !material.materialStatus.isPicked && !material.materialStatus.isNotReceived }">
        <div class="d-flex flex-wrap flex-md-nowrap align-items-center pb-3">
            <!--status and expand collapse icons-->
            <div class="col-md-1 col-2 limited-col-width horizontal-icons-list" (click)="onItemClick(material)">
                <div
                    class="first-row d-flex align-items-center"
                    [ngClass]="{
                        'ng-invalid': !material.materialStatus.isPicked && !material.materialStatus.isNotReceived,
                    }"
                >
                    <ng-container *ngIf="material.materialStatus.isPicked || material.materialStatus.isNotReceived">
                        <fa-icon
                            *ngIf="!material.materialStatus.isNotReceived && !material.isCollapsed"
                            [icon]="faChevronDown"
                        ></fa-icon>
                        <fa-icon
                            *ngIf="!material.materialStatus.isNotReceived && material.isCollapsed"
                            [icon]="faChevronRight"
                        ></fa-icon>
                        <fa-icon *ngIf="material.materialStatus.isNotReceived" [icon]="faBan"></fa-icon>
                    </ng-container>
                    <span
                        *ngIf="material.materialStatus.isOrderedOrPicked"
                        id="statusIcon"
                        class="form-status-icon"
                        [ngClass]="
                            materialConsumptionRowForm.status === formInvalid ? 'invalid-status' : 'valid-status'
                        "
                    ></span>
                </div>
            </div>

            <!--small resolution screen-->
            <div class="d-lg-none d-flex flex-column col-md-8 col-10">
                <div class="d-flex flex-wrap align-items-center">
                    <label
                        class="col-6 col-md-4 col-form-label text-lg-end text-start"
                        translate="CONFIRMATION_MATERIAL_HEADER_MATNO"
                    ></label>
                    <div class="col-6 col-md-8">
                        <ng-container *ngTemplateOutlet="materialNumberDetail"></ng-container>
                    </div>
                </div>
                <div class="d-flex flex-wrap align-items-center">
                    <label
                        for="dropdownBillable"
                        class="col-6 col-md-4 col-form-label text-lg-end text-start"
                        translate="CONFIRMATION_MATERIAL_HEADER_PO"
                    ></label>
                    <div class="col-6 col-md-8" (click)="onItemClick(material)">
                        <ng-container *ngTemplateOutlet="orderPos"></ng-container>
                    </div>
                </div>
                <div class="d-flex flex-wrap align-items-center">
                    <label
                        class="col-6 col-md-4 col-form-label text-lg-end text-start"
                        translate="CONFIRMATION_MATERIAL_HEADER_DESC"
                    ></label>
                    <div class="col-6 col-md-8">{{ material.description.value }}</div>
                </div>
                <div class="d-flex flex-wrap align-items-center">
                    <label
                        for="dropdownBillable"
                        class="col-6 col-md-4 col-form-label text-lg-end text-start"
                        translate="CONFIRMATION_MATERIAL_HEADER_QUANTITY"
                    ></label>
                    <div class="col-6 col-md-8">
                        <ng-container *ngTemplateOutlet="quantityStepper"></ng-container>
                    </div>
                </div>
                <div class="d-flex flex-wrap align-items-center">
                    <label
                        class="col-6 col-md-4 col-form-label text-lg-end text-start"
                        translate="CONFIRMATION_MATERIAL_HEADER_UNIT"
                    ></label>
                    <div class="col-6 col-md-8">{{ material.quantityUnit.value }}</div>
                </div>
            </div>

            <!--big resolution screen-->
            <div class="col-2 d-lg-flex d-none first-row">
                <ng-container *ngTemplateOutlet="materialNumberDetail"></ng-container>
            </div>
            <div class="col-2 d-lg-flex d-none first-row">
                <div (click)="onItemClick(material)">
                    <ng-container *ngTemplateOutlet="orderPos"></ng-container>
                </div>
            </div>
            <div class="col-2 d-lg-flex d-none first-row" (click)="onItemClick(material)">
                {{ material.description.value }}
            </div>
            <div class="col-2 d-lg-flex d-none first-row">
                <ng-container *ngTemplateOutlet="quantityStepper"></ng-container>
            </div>
            <div class="col-1 d-lg-flex d-none first-row">{{ material.quantityUnit.value }}</div>

            <!--declare button-->
            <div class="col-8 col-sm-10 col-md-3 offset-md-1 offset-lg-0 offset-2 justify-content-center">
                <button
                    type="button"
                    class="btn col-12 col-sm-8 btn-primary"
                    [ngClass]="{
                        'btn-primary': !material.isConsumed && !material.materialStatus.isNotReceived,
                        'btn-secondary': material.isConsumed || material.materialStatus.isNotReceived,
                    }"
                    (click)="consumeMaterial(material, index)"
                >
                    <span *ngIf="material.materialStatus.isPicked"> <fa-icon [icon]="faCheck"></fa-icon>&nbsp; </span>
                    <span
                        *ngIf="!material.isConsumed && !isAlreadyReturned(material)"
                        translate="CONFIRMATION_MATERIAL_LABEL_CONSUME"
                    ></span>
                    <span
                        *ngIf="material.isConsumed && !isAlreadyReturned(material)"
                        translate="CONFIRMATION_MATERIAL_LABEL_CONSUMED"
                    ></span>
                    <span
                        *ngIf="isAlreadyReturned(material)"
                        [translate]="getDeclaredOrReturnButtonLabel(material)"
                    ></span>
                </button>
                <button
                    *ngIf="showDeleteButton(material)"
                    type="button"
                    class="btn btn-warning"
                    (click)="deleteRow(index)"
                >
                    <fa-icon [icon]="faTrashAlt"></fa-icon>
                </button>
            </div>
        </div>
        <div [ngClass]="{ collapse: material.isCollapsed, 'd-flex': !material.isCollapsed }">
            <div class="col-md-1 col-2 limited-col-width"></div>
            <div class="col-md-8 col-sm-10 col-lg-10">
                <div class="d-flex flex-wrap align-items-center">
                    <!-- Consumed-->
                    <ng-container>
                        <label
                            for="dropdownConsumed"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3 mb-lg-3 mb-0"
                            translate="CONFIRMATION_MATERIAL_CONSUMED_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4 mb-3">
                            <pace-core-dropdown
                                id="dropdownConsumed"
                                [(model)]="material.consumptionCode"
                                [parentForm]="materialConsumptionRowFormChildren"
                                (valueChange)="onConsumeChange(material)"
                            ></pace-core-dropdown>
                        </div>
                    </ng-container>

                    <!--Show Billable Only When Consumed is selected-->
                    <ng-container *ngIf="isMaterialConsumed(material) && material.billableCode.value.length">
                        <label
                            for="dropdownBillable"
                            class="col-12 col-lg-2 col-sm-8 col-form-label text-lg-end text-start pe-3 mb-lg-3 mb-0"
                            translate="CONFIRMATION_MATERIAL_BILLABLE_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4 mb-3">
                            <pace-core-dropdown
                                id="dropdownBillable"
                                [(model)]="material.billableCode"
                                [parentForm]="materialConsumptionRowFormChildren"
                                (valueChange)="onBillableChange()"
                            ></pace-core-dropdown>
                        </div>
                    </ng-container>
                </div>
                <div class="d-flex flex-wrap align-items-center" *ngIf="material.showFDA2579Form()">
                    <ng-container>
                        <label
                            for="FDA2579"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3 mb-lg-3 mb-0"
                            translate="FDA_2579_FORM_TITLE"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4 mb-3">
                            <button
                                type="button"
                                id="FDA2579"
                                class="btn btn-primary"
                                [ngClass]="!material.isFDA2579FormInvalid() ? 'btn-primary' : 'btn-danger'"
                                (click)="openFDA2579()"
                                translate="CONFIRMATION_MATERIAL_FDA_2579_FORM_BUTTON_INFO_LABEL"
                            ></button>
                        </div>
                    </ng-container>
                </div>

                <ng-container *ngIf="material.isMaterialConsumptionAdditionalTaxiCost">
                    <div
                        class="d-flex mb-3 offset-lg-2 me-3 info-text"
                        translate="CONFIRMATION_MATERIAL_TAXI_ADDITIONAL_COST"
                    ></div>
                </ng-container>

                <!--Dangerous Good-->
                <ng-container *ngIf="material.showDangerousInfo">
                    <div class="d-flex flex-wrap align-items-center mb-3">
                        <label
                            class="col-6 col-md-4 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="CONFIRMATION_MATERIAL_ATTENTION_INFO_LABEL"
                        >
                        </label>
                        <div class="col-6 col-md-8 col-lg-4">
                            <button
                                type="button"
                                class="btn btn-warning"
                                translate="CONFIRMATION_MATERIAL_ATTENTION_INFO_BUTTON_LABEL"
                                (click)="showMoreInfo(material)"
                            ></button>
                        </div>
                    </div>
                </ng-container>

                <!--Complaints-->
                <ng-container *ngIf="displayComplaintPart$ | async">
                    <div class="d-flex flex-wrap align-items-center mb-3">
                        <label
                            for="chkComplaint"
                            class="col-12 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="CONFIRMATION_MATERIAL_COMPLAINTS_LABEL"
                        >
                        </label>
                        <div class="col-12 col-lg-4">
                            <pace-core-radio-input
                                id="chkComplaint"
                                [parentForm]="materialConsumptionRowFormChildren"
                                [(model)]="material.isComplaint"
                                (valueChange)="onComplaintsCheckChange(material, true)"
                            >
                            </pace-core-radio-input>
                        </div>
                    </div>
                </ng-container>

                <!--Datenträger-->
                <!--Show Datenträger (PHI Dropdown) Only When TUBE_INDICATOR = H or M && ConsumptionCode = C-->
                <ng-container *ngIf="displayPHIDropdown$ | async">
                    <div class="d-flex flex-wrap align-items-center mb-3">
                        <label
                            for="dropdownPHIData"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="CONFIRMATION_MATERIAL_PHIDATACODE"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-dropdown
                                id="dropdownPHIData"
                                [(model)]="material.phiDataCode"
                                [parentForm]="materialConsumptionRowFormChildren"
                            ></pace-core-dropdown>
                        </div>
                    </div>
                </ng-container>

                <!--Customer Price-->
                <ng-container *ngIf="displayCustomerPrice && !displayAmount">
                    <div class="d-flex flex-wrap align-items-center mb-3">
                        <label
                            class="col-6 col-md-4 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="CONFIRMATION_MATERIAL_CUSTOMER_PRICE_LABEL"
                        ></label>
                        <div class="col-6 col-md-8 col-lg-4">{{ formatCurrency(price) }} {{ currency }}</div>
                    </div>
                </ng-container>

                <!--Amount-->
                <ng-container *ngIf="displayAmount">
                    <div class="d-flex flex-wrap align-items-center mb-3">
                        <label
                            class="col-6 col-md-4 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="CONFIRMATION_MATERIAL_CUSTOMER_PRICE_LABEL"
                        ></label>
                        <div class="col-6 col-md-8 col-lg-4">
                            {{ formatCurrency(material.amount.value) }} {{ material.currency }}
                        </div>
                    </div>
                </ng-container>

                <!--Battery Removed-->
                <ng-container *ngIf="displayBatteryRemoved$ | async">
                    <div class="d-flex flex-wrap align-items-center mb-3">
                        <label
                            for="chkBatteryRemoved"
                            class="col-12 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="CONFIRMATION_MATERIAL_BATTERY_REMOVED_QUESTION_LABEL"
                        >
                        </label>
                        <div class="col-12 col-lg-4">
                            <pace-core-radio-input
                                id="chkBatteryRemoved"
                                [(model)]="material.isBatteryRemoved"
                                [parentForm]="materialConsumptionRowFormChildren"
                                (valueChange)="onBatteryRemovedChange()"
                            >
                            </pace-core-radio-input>
                        </div>
                    </div>
                </ng-container>

                <!--Battery Damaged-->
                <ng-container *ngIf="displayBatteryDamaged$ | async">
                    <div class="d-flex flex-wrap align-items-center mb-3">
                        <label
                            for="chkBatteryDamaged"
                            class="col-12 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="CONFIRMATION_MATERIAL_BATTERY_DAMAGED_QUESTION_LABEL"
                        >
                        </label>
                        <div class="col-12 col-lg-4">
                            <pace-core-radio-input
                                id="chkBatteryDamaged"
                                [(model)]="material.isBatteryDamaged"
                                [parentForm]="materialConsumptionRowFormChildren"
                                (valueChange)="onBatteryDamagedChange()"
                            >
                            </pace-core-radio-input>
                        </div></div
                ></ng-container>

                <ng-container *ngIf="displayInputFields(material)">
                    <!--Return-->
                    <div
                        class="d-flex flex-wrap align-items-center"
                        [ngClass]="{ 'mb-3': isConsumedOrReturned(material) || showReturnReasonField(material) }"
                    >
                        <!--Show Return Type only if "Consumed" or "Return Without Consumption" selected-->
                        <ng-container *ngIf="isConsumedOrReturned(material)">
                            <label
                                for="dropdownReturnType"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="CONFIRMATION_MATERIAL_RETURN_TYPE_LABEL"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4 mb-3 mb-lg-0">
                                <pace-core-dropdown
                                    id="dropdownReturnType"
                                    [(model)]="material.returnType"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                    (valueChange)="onReturnTypeChange(material)"
                                ></pace-core-dropdown>
                            </div>
                        </ng-container>
                        <!--Show Return Reason only if "Return Without Consumption" and Return type "Central return" selected-->
                        <ng-container *ngIf="showReturnReasonField(material)">
                            <label
                                for="dropdownReturnReason"
                                class="col-12 col-lg-2 col-sm-8 col-form-label text-lg-end text-start pe-3"
                                translate="CONFIRMATION_MATERIAL_RETURN_REASON_LABEL"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-dropdown
                                    [(model)]="material.returnReason"
                                    id="dropdownReturnReason"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                    (valueChange)="onReturnReasonChange(material)"
                                ></pace-core-dropdown>
                            </div>
                        </ng-container>
                    </div>

                    <!--Service Part Questionnaire-->
                    <ng-container *ngIf="displayQuestionnaire$ | async">
                        <div class="d-flex flex-wrap align-items-center mb-3">
                            <label
                                class="col-6 col-md-4 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="CONFIRMATION_MATERIAL_QUESTIONNAIRE_LABEL"
                            >
                            </label>
                            <div class="col-6 col-md-8 col-lg-4">
                                <button
                                    type="button"
                                    class="btn"
                                    [ngClass]="isQuestionnaireSubmitted ? 'btn-primary' : 'btn-danger'"
                                    [disabled]="isQuestionnaireSubmitted"
                                    translate="{{
                                        isQuestionnaireSubmitted
                                            ? 'CONFIRMATION_MATERIAL_QUESTIONNAIRE_SUBMITTED_BUTTON_LABEL'
                                            : 'CONFIRMATION_MATERIAL_OPEN_QUESTIONNAIRE_BUTTON_LABEL'
                                    }}"
                                    (click)="openQuestionnaire()"
                                ></button>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Fault -->
                    <ng-container *ngIf="displayMaterialFaultCodeAndText$ | async">
                        <div class="d-flex flex-wrap mb-3 align-items-center">
                            <label
                                for="dropdownFaultCode"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="CONFIRMATION_MATERIAL_FAULT_CODE_LABEL"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-dropdown
                                    id="dropdownFaultCode"
                                    [(model)]="material.faultCode"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                    (valueChange)="onFaultCodeChange(material)"
                                ></pace-core-dropdown>
                            </div>
                        </div>
                        <div class="d-flex flex-wrap mb-3 align-items-center">
                            <label
                                for="txtFaultDescription"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="CONFIRMATION_MATERIAL_FAULT_DESC_LABEL"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-text-input
                                    id="txtFaultDescription"
                                    [(model)]="material.faultDescription"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                ></pace-core-text-input>
                            </div>
                        </div>
                    </ng-container>

                    <!--Material Number Old-->
                    <!--Show Material Number Only When Consumed is selected && Return Type is "Central Return"-->
                    <ng-container *ngIf="showMaterialOldField(material)">
                        <div class="d-flex flex-wrap mb-3">
                            <label
                                for="txtMaterialNumberOld"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="CONFIRMATION_MATERIAL_MATNROLD"
                            ></label>
                            <div class="col-10 col-sm-8 col-lg-4">
                                <pace-core-text-input
                                    [(model)]="material.materialNumberOld"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                    id="txtMaterialNumberOld"
                                ></pace-core-text-input>
                            </div>
                            <div class="col-2 ps-3">
                                <button class="btn btn-secondary" (click)="copyMaterialNumber(material)">
                                    <fa-icon [rotate]="90" [icon]="faPause" size="lg"></fa-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>

                    <!--AWB Delivery-->
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <ng-container *ngIf="displayAWBNumber">
                            <label
                                class="col-6 col-md-4 col-lg-2 col-form-label text-lg-end text-start pe-3 mb-3 mb-lg-0"
                                translate="CONFIRMATION_MATERIAL_AWBDELIVERY"
                            ></label>
                            <div class="col-6 col-md-8 col-lg-4 mb-3 mb-lg-0">{{ material.awbDelivery }}</div>
                        </ng-container>

                        <ng-container
                            *ngIf="
                                displayBatchNumber(material) &&
                                (material.batchNumberLegacy || material.batchNumber.value)
                            "
                        >
                            <label
                                class="col-6 col-md-4 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="CONFIRMATION_MATERIAL_BATCHNUMBER"
                            ></label>
                            <div class="col-6 col-md-8 col-lg-4">
                                {{
                                    material.batchNumberLegacy ? material.batchNumberLegacy : material.batchNumber.value
                                }}
                            </div>
                        </ng-container>
                    </div>

                    <!--Serial Number-->
                    <!--Show serial number only if "Not Received" is not selected and serialPIndicator is "J"-->
                    <ng-container *ngIf="showFieldWithSerialPJIndicator(material)">
                        <div class="d-flex flex-wrap mb-3 align-items-center">
                            <label
                                for="txtSerialNumberOldDropdown"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="CONFIRMATION_MATERIAL_SERNR_OLD"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4 mb-3 mb-lg-0">
                                <pace-core-dropdown
                                    [(model)]="material.serialNumberDropdown"
                                    id="txtSerialNumberOldDropdown"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                ></pace-core-dropdown>
                            </div>
                            <label
                                for="txtSerialNumberNew"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="CONFIRMATION_MATERIAL_SERNR_NEW"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-text-input
                                    id="txtSerialNumberNew"
                                    [(model)]="material.serialNumberNew"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                ></pace-core-text-input>
                            </div>
                        </div>
                    </ng-container>

                    <!--Revision Number-->
                    <!--Show revision number only if "Not Received" is not selected and serialPIndicator is "J"-->
                    <ng-container *ngIf="showFieldWithSerialPJIndicator(material)">
                        <div class="d-flex flex-wrap align-items-center mb-3">
                            <label
                                for="txtRevisionNumberOld"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="CONFIRMATION_MATERIAL_REVISION_OLD"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4 mb-3 mb-lg-0">
                                <pace-core-text-input
                                    id="txtRevisionNumberOld"
                                    [(model)]="material.revisionNumberOld"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                ></pace-core-text-input>
                            </div>
                            <label
                                for="txtRevisionNumberNew"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="CONFIRMATION_MATERIAL_REVISION_NEW"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-text-input
                                    id="txtRevisionNumberNew"
                                    [(model)]="material.revisionNumberNew"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                ></pace-core-text-input>
                            </div>
                        </div>
                    </ng-container>

                    <!--InstDate Number-->
                    <ng-container *ngIf="displayInstallationDateFields(material)">
                        <div class="d-flex flex-wrap align-items-center mb-3">
                            <label
                                for="txtInstDateOld"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                >{{ instDateOldLabel }}</label
                            >
                            <div class="col-12 col-sm-8 col-lg-4 mb-3 mb-lg-0">
                                <pace-core-date-input
                                    id="txtInstDateOld"
                                    [(model)]="material.installationDateOld"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                    (valueChange)="validateInstallDate(material)"
                                ></pace-core-date-input>
                            </div>
                            <label
                                for="txtInstDateNew"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                >{{ instDateNewLabel }}</label
                            >
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-date-input
                                    id="txtInstDateNew"
                                    [(model)]="material.installationDateNew"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                    (valueChange)="validateInstallDate(material)"
                                ></pace-core-date-input>
                            </div>
                        </div>
                    </ng-container>

                    <!--Counter Number-->
                    <ng-container *ngIf="displayCounterFields(material)">
                        <div class="d-flex flex-wrap align-items-center mb-3">
                            <label
                                for="txtCounterOld"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                >{{ counterOldLabel }}</label
                            >
                            <div class="col-12 col-sm-8 col-lg-4 mb-3 mb-lg-0">
                                <pace-core-number-input
                                    id="txtCounterOld"
                                    [(model)]="material.counterNumberOld"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                ></pace-core-number-input>
                            </div>
                            <label
                                for="txtCounterNew"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                >{{ counterNewLabel }}</label
                            >
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-number-input
                                    id="txtCounterNew"
                                    [(model)]="material.counterNumberNew"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                ></pace-core-number-input>
                            </div>
                        </div>
                    </ng-container>

                    <!-- AWB Return -->
                    <ng-container *ngIf="displayAWBReturnField$ | async">
                        <div class="d-flex flex-wrap align-items-center mb-3">
                            <label
                                for="txtAwbReturn"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                >{{ getAwbReturnLabel(material) }}</label
                            >
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-text-input
                                    id="txtAwbReturn"
                                    [(model)]="material.awbReturn"
                                    [parentForm]="materialConsumptionRowFormChildren"
                                    (valueChange)="checkAwbValidity(material)"
                                    [ariaLabel]="getAwbReturnLabel(material)"
                                ></pace-core-text-input>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </fieldset>
</div>

<ng-template #materialNumberDetail>
    {{ material.materialIdentifier.materialNumber.value }}
    <fa-icon *ngIf="material.showDangerousInfo" class="ps-1" [icon]="faExclamationTriangle"></fa-icon>
    <fa-icon *ngIf="material.isQualityPart" [icon]="faSearch" class="ps-1"></fa-icon>
    <fa-icon *ngIf="material.isRentalTool" [icon]="faWrench" class="ps-1"></fa-icon>
</ng-template>

<ng-template #orderPos>
    {{ material.materialIdentifier.orderNumber.value }} | {{ material.materialIdentifier.orderPosition.value }}
    <fa-icon *ngIf="material.isPurchaseOrderTaxiBillable" [icon]="faTaxi"></fa-icon>
</ng-template>

<ng-template #quantityStepper>
    <pace-core-number-stepper
        [(model)]="material.quantity"
        [parentForm]="materialConsumptionRowFormChildren"
        (valueChange)="splitRow(material, index)"
        [ariaLabel]="'CONFIRMATION_MATERIAL_STOCK_QUANTITY_ARIA_LABEL' | translate"
    ></pace-core-number-stepper>
</ng-template>
